export enum MonitorPermissionEnum {
  ADMIN = 'Gestão',
  EDITOR = 'Edição',
  VIEWER = 'Visualização',
}
